import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
/* MUI Imports */
import {
  useTheme,
  Box,
  MenuItem,
  FormControl,
  Chip,
  Select,
  OutlinedInput,
} from "@material-ui/core";

import CancelIcon from "@material-ui/icons/Cancel";
/* Style */
import { useStyles } from "./ChipMultiSelectWithDelete.styles";
import clsx from "clsx";

/* Utilities */
import * as _ from "lodash";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  variant: "menu",
  getContentAnchorEl: null,
};

function getStyles(id, chips, theme) {
  const selected = !_.isUndefined(chips.find((x) => x.id === id));
  return {
    fontWeight: selected
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
    background: selected ? theme.palette.selectedItem?.main : undefined,
  };
}

const ChipMultiSelectWithDelete = ({
  identifier,
  className,
  options,
  onChange,
  selected,
  placeholder,
  isError
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const [chips, setChips] = useState([]);

  useEffect(() => {
    if (selected) setChips(selected);
  }, selected);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const addedWithSelection = value.length > chips.length;
    let newChips = [...chips];
    let chipsIDs = chips.map((x) => x.id);
    if (addedWithSelection) {
      const id = value.filter((x) => !chipsIDs.includes(x))[0];
      let newIndex = findOptionObject(id)
      newChips = [...newChips, newIndex]
    } else {
      const index = chipsIDs.findIndex((x) => !value.includes(x));
      newChips.splice(index, 1);
    }

    setChips(newChips);
    onChange(newChips);
  };

  const findOptionObject = (id) => {
    const option = options?.find((opt) => opt.id === id)
    return option;
  };

  const findChipValue = (id) => {
    return options?.find((opt) => opt.id === id)?.value;
  };

  const handleDelete = (event, value) => {
    let newChips = [...chips];
    newChips = newChips.filter((chip) => chip.id !== value);
    setChips(newChips);
    onChange(newChips);
  }

  return (
    <div className={clsx(className, classes.root)} id="multiple-chip-main-del">
      <FormControl className={classes.rootFormControl} variant="outlined" error={isError} size="small" id="multiple-chip-Form-del">
        <Select
          labelId="multiple-chip-label-del"
          id="multiple-chip-del"
          className={classes.multiplechipdel}
          data-testid={identifier}
          multiple
          displayEmpty
          value={chips?.map((chip) => chip.id)}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip-del" margin="dense" sx={{ input: { paddingTop: "2px !important", paddingBottom: "2px !important" } }} />}
          renderValue={(selected) => (
            <>
              {selected.length === 0 ?
                <span style={{ color: isError ? "red" : "inherit" }}>{placeholder}</span> :
                <Box className={classes.selectedChipContainer}>
                  {selected.map((item) => (
                    <Chip
                      size="small"
                      className={`chip-del-${item}`}
                      key={item}
                      label={findChipValue(item)}
                      onDelete={(event) => handleDelete(event, item)}
                      deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} data-testid={`chip-delete-${item}`} />}
                      style={{
                        borderRadius: '4px',
                        marginLeft: '4px',
                        marginTop: '4px',
                      }}
                      clickable={false}
                    />
                  ))}
                </Box>
              }
            </>
          )}
          MenuProps={MenuProps}
          sx={{ input: { paddingTop: "2px !important", paddingBottom: "2px !important" } }}
        >
          <MenuItem disabled value="">
            None
          </MenuItem>
          {options.map((item) => (
            !chips.some((chip) => chip.id === item.id) && (
              <MenuItem
                className={`multi-select-option-del-${item.id}`}
                key={item.id}
                value={item.id}
                style={getStyles(item.id, chips, theme)}
              >
                {item.value}
              </MenuItem>
            )
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

ChipMultiSelectWithDelete.defaultProps = {
  identifier: "chip-multi-textfield-del",
  options: [],
  onChange: () => { },
  selected: [],
};

ChipMultiSelectWithDelete.propTypes = {
  identifier: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.any,
    })
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.any,
    })
  ),
  onChange: PropTypes.func,
};

export default ChipMultiSelectWithDelete;